import { INSPECTOR_OVERLOADRELAY } from "../../../constants/inspectorConstants";
import Symbol from "./Symbol";

// Relevador de sobrecarga (protección de motores)
class OverloadRelay extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("OverloadRelay", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
        };                
    }

    getInspector() {
        return INSPECTOR_OVERLOADRELAY;
    }
}

export default OverloadRelay;
